<template>
  <a-modal
    :title="title"
    width="800px"
    :visible="true"
    :maskClosable="false"
    :confirmLoading="loading"
    cancelText="取消"
    okText="知道了"
    centered
    @ok="handleSubmit"
    @cancel="
      () => {
        // resetFields();
        $emit('cancel');
      }
    "
  >
    <a-row>
      <a-col :span="12">
        <a-card title="服务前">
          <a-image
            :width="108"
            v-for="img in before_image_obj_list"
            :src="img.url"
            :key="img.url"
            @click="handlerBeforeDelete(img)"
            :preview="false"
          />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="服务后">
          <a-image
            :width="108"
            v-for="img in after_image_obj_list"
            :src="img.url"
            :key="img.url"
            @click="handlerAfterDelete(img)"
            :preview="false"
          />
        </a-card>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts">
import { computed, createVNode, defineComponent } from 'vue';
import { update_service_detail_image } from '@/api/mjstore-model';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';

export default defineComponent({
  name: 'DoubleImageEditModal',
  props: {
    before_image_list: {
      type: Array,
      required: true,
    },
    after_image_list: {
      type: Array,
      required: true,
    },
    obj: {
      type: Object,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    let info: any = null;
    const handleSubmit = (e: Event) => {
      e.preventDefault();

      emit('ok', info);
    };

    const before_image_obj_list = computed(() => {
      return props.before_image_list.filter((item: any) => {
        return !item.is_hide;
      });
    });
    const after_image_obj_list = computed(() => {
      return props.after_image_list.filter((item: any) => {
        return !item.is_hide;
      });
    });

    const handlerBeforeDelete = (img: any) => {
      Modal.confirm({
        title: '是否删除图片?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            update_service_detail_image({
              service_detail_id: props.obj.id,
              image_update_type: 'remove',
              ids: img.file_id,
              image_type: 'before',
              org_id: current_org?.id,
            })
              .then(res => {
                message.success('删除成功');
                img.is_hide = true;
                resolve(null);
                info = res;
              })
              .finally(() => {});
          }).catch(() => console.log('Oops errors!'));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      });
    };

    const handlerAfterDelete = (img: any) => {
      Modal.confirm({
        title: '是否删除图片?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            update_service_detail_image({
              service_detail_id: props.obj.id,
              image_update_type: 'remove',
              ids: img.file_id,
              image_type: 'after',
              org_id: current_org?.id,
            })
              .then(res => {
                message.success('删除成功');
                img.is_hide = true;
                resolve(null);
                info = res;
              })
              .finally(() => {});
          }).catch(() => console.log('Oops errors!'));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      });
    };

    return {
      props,
      handleSubmit,
      handlerBeforeDelete,
      handlerAfterDelete,
      before_image_obj_list,
      after_image_obj_list,
    };
  },
});
</script>
